import React from 'react';
import Header from '../components/Header';
import AgilysysLogo from '../components/AgilysysLogo';
import bubblesImg from '../assets/products/aboutAgilysysCommunityBubbles.png';

const AboutUsPage = () => {
  return (
    <div className="page aboutUsPage">
      <div className="background" />
      <Header />

      <div className="logo">
        <AgilysysLogo />
      </div>

      <div className="triple-text">
        <span>{"Food Service\n"}</span>
        <span>{"Software Technology\n"}</span>
        <span>for Residential Life Communities</span>
      </div>

      <div className="bottom-bar">
        <span>
          {"Agilysys offers the broadest portfolio of Life Plan\nCommunity solutions with the deepest functionality in the\nmarket, delighting residents and empowering staff to\nprovide exceptional service at every touchpoint."}
        </span>
      </div>

      <img
        className="bubbles"
        src={bubblesImg}
        alt="Agilysys solutions"
      />
    </div>
  );
};

export default AboutUsPage;
